import { __spreadArray } from '../../node_modules/tslib/tslib.es6.js';
import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';
import ReactTextTransition, { presets } from 'react-text-transition';
import { Navigation } from 'swiper';
import { styled, Grid } from '@mui/material';
import { GenericContainer } from '../components/GenericContainer.js';
import { WIDGET_SPACE, TABLET_SCREEN_SIZE, WIDGET_SPACE_HALF, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING } from '../../utils/constants/Constants.js';
import brandclub_colors from '../../colors/brandclubColors.js';
import { BrandclubVideo } from '../components/BrandclubVideo.js';

var _a, _b, _c, _d, _e, _f, _g, _h, _j;
var VideoCarouselContainer = styled(GenericContainer)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: WIDGET_SPACE,
            paddingBottom: WIDGET_SPACE,
            paddingLeft: '5%',
            paddingRight: '5%',
            boxSizing: 'border-box',
            color: theme.palette.primary.main,
            background: brandclub_colors.greyBlackGround
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            background: brandclub_colors.greyBlackGround,
            padding: "".concat(WIDGET_SPACE_HALF, "px 0px ").concat(WIDGET_SPACE_HALF, "px 0px"),
        },
        _b);
});
var Wrapper = styled('div')((_a = {
        width: '100%',
        maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
        // maxWidth: 1000,
        position: 'relative',
        padding: '0 40px',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    _a["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        maxWidth: '100%',
        padding: '0 0',
    },
    _a['.swiper'] = (_b = {
            position: 'static',
            maxWidth: '100%',
            '&.mobile_swiper': {
                display: 'none',
            },
            '&.desktop_swiper': {
                display: 'block',
            }
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            '&.mobile_swiper': {
                display: 'block',
            },
            '&.desktop_swiper': {
                display: 'none',
            },
            maxWidth: '100%',
        },
        _b),
    _a['.swiper-wrapper'] = {
        alignItems: 'center',
    },
    _a['.swiper-slide'] = (_c = {
            margin: 0,
            // maxHeight: 430,
            // height: 430,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        _c["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            // maxHeight: 630,
            height: 'unset',
        },
        _c),
    _a['.swiper-button-prev'] = (_d = {
            background: "url(https://media.brandclub.com/brandclub/image_asset/arrow_left_blue.svg)",
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            width: 40,
            height: 40,
            left: -15
        },
        _d["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            display: 'none',
        },
        _d['::after'] = {
            content: '""',
        },
        _d),
    _a['.swiper-button-next'] = (_e = {
            background: "url(https://media.brandclub.com/brandclub/image_asset/arrow_right_blue.svg)",
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            width: 40,
            height: 40,
            right: -15
        },
        _e["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            display: 'none',
        },
        _e['::after'] = {
            content: '""',
        },
        _e),
    _a['.swiper-button-disabled'] = {
        display: 'none',
    },
    _a));
var AvatorContainer = styled(Grid)((_f = {
        cursor: 'pointer',
        margin: 'auto',
        flexDirection: 'row',
        justifyContent: 'center',
        width: '100%',
        // img: { boxSizing: 'border-box', width: 80, height: 80, borderRadius: 200, padding: 4, border: '4px solid #dcdcdc' },
        transform: 'scale(.7)',
        transition: 'all 300ms ease-in'
    },
    _f["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        transform: 'scale(1)',
    },
    _f['.name'] = {
        marginTop: 10,
        transition: 'opacity 300ms ease-in',
        opacity: 0,
    },
    _f['.city'] = {
        transition: 'opacity 300ms ease-in',
        opacity: 0,
    },
    _f['&.active'] = {
        // img: { border: '4px solid #ffc220' },
        transform: 'scale(1)',
        '.name': {
            opacity: 1,
            fontSize: 23,
            fontWeight: 600,
            whiteSpace: 'nowrap',
        },
        '.city': {
            opacity: 1,
            fontSize: 16,
            fontWeight: 500,
            whiteSpace: 'nowrap',
        },
    },
    _f));
var FeedbackContainer = styled('div')((_g = {
        maxWidth: 830,
        minHeight: 95,
        margin: '30px auto 15px auto',
        fontSize: 32,
        fontWeight: 600,
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center'
    },
    _g["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        display: 'none',
    },
    _g));
var NameContainer = styled('div')((_h = {
        maxWidth: 830,
        fontWeight: 700,
        fontSize: 28,
        minHeight: 43,
        // margin: '25px auto',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center'
    },
    _h["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        display: 'none',
    },
    _h));
var LocationContainer = styled('div')((_j = {
        maxWidth: 830,
        minHeight: 33,
        fontSize: 22,
        textAlign: 'center',
        display: 'flex',
        fontWeight: 500,
        fontStyle: 'italic',
        justifyContent: 'center'
    },
    _j["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        display: 'none',
    },
    _j));
var SingleVideo = function (_a) {
    var video = _a.video, coverImage = _a.coverImage, active = _a.active, activeCallBack = _a.activeCallBack, handleClick = _a.handleClick;
    useEffect(function () {
        if (active) {
            activeCallBack();
        }
    }, [active]);
    return (React.createElement(AvatorContainer, { role: "button", onClick: handleClick, container: true, className: "".concat(active ? 'active' : '') },
        React.createElement(BrandclubVideo, { videoUrl: video, posterUrl: coverImage, canPlay: active })));
};
var VideoCarousel = function (_a) {
    var items = _a.items;
    var _b = useState({
        testimonial: '',
        name: '',
        location: '',
    }), item = _b[0], setItem = _b[1];
    var _c = useState(null), swiperMobIns = _c[0], setSwiperMobIns = _c[1];
    var _d = useState(null), swiperDesIns = _d[0], setSwiperDesIns = _d[1];
    return (React.createElement(VideoCarouselContainer, null,
        React.createElement(Wrapper, null,
            React.createElement(Swiper, { className: "mobile_swiper", allowTouchMove: true, 
                // allowSlidePrev={false}
                slidesPerView: 2, spaceBetween: 10, centeredSlides: true, modules: [Navigation], navigation: true, loop: true, onSwiper: function (s) { return setSwiperMobIns(s); } }, __spreadArray([], items, true).map(function (item, idx) {
                return (React.createElement(SwiperSlide, { key: idx, style: {} }, function (_a) {
                    var isActive = _a.isActive, isNext = _a.isNext, isPrev = _a.isPrev;
                    return (React.createElement(SingleVideo, { video: item.video, coverImage: item.coverImage, active: isActive, handleClick: function () {
                            if (isNext) {
                                swiperMobIns === null || swiperMobIns === void 0 ? void 0 : swiperMobIns.slideNext();
                            }
                            else if (isPrev) {
                                swiperMobIns === null || swiperMobIns === void 0 ? void 0 : swiperMobIns.slidePrev();
                            }
                        }, activeCallBack: function () { return setItem(item); } }));
                }));
            })),
            React.createElement(Swiper, { className: "desktop_swiper", allowTouchMove: false, 
                // allowSlidePrev={false}
                slidesPerView: 3, spaceBetween: 0, centeredSlides: true, modules: [Navigation], navigation: true, loop: true, onSwiper: function (s) { return setSwiperDesIns(s); } }, __spreadArray([], items, true).map(function (item, idx) {
                return (React.createElement(SwiperSlide, { key: idx, style: {} }, function (_a) {
                    var isActive = _a.isActive, isNext = _a.isNext, isPrev = _a.isPrev;
                    return (React.createElement(SingleVideo, { video: item.video, coverImage: item.coverImage, active: isActive, handleClick: function () {
                            if (isNext) {
                                swiperDesIns === null || swiperDesIns === void 0 ? void 0 : swiperDesIns.slideNext();
                            }
                            else if (isPrev) {
                                swiperDesIns === null || swiperDesIns === void 0 ? void 0 : swiperDesIns.slidePrev();
                            }
                        }, activeCallBack: function () { return setItem(item); } }));
                }));
            }))),
        React.createElement(Wrapper, null,
            React.createElement(FeedbackContainer, null,
                React.createElement(ReactTextTransition, { style: { width: '100%', overflow: 'hidden' }, springConfig: presets.stiff }, item.testimonial)),
            React.createElement(NameContainer, null,
                React.createElement(ReactTextTransition, { style: { width: '100%', overflow: 'hidden' }, springConfig: presets.stiff }, item.name)),
            React.createElement(LocationContainer, null,
                React.createElement(ReactTextTransition, { style: { width: '100%', overflow: 'hidden' }, springConfig: presets.stiff }, item.location)))));
};

export { VideoCarousel };
//# sourceMappingURL=index.js.map
